const userList = () => import('./registerUserManagement');

const USER = [
  {
    path: 'registerUserManagement',
    name: 'registerUserManagement',
    component: userList,
    meta: {
      title: '注册用户管理'
    }
  }
];
export default USER;